import { render, staticRenderFns } from "./mainView.vue?vue&type=template&id=4afd368a&scoped=true"
import script from "./mainView.vue?vue&type=script&lang=js"
export * from "./mainView.vue?vue&type=script&lang=js"
import style0 from "./mainView.vue?vue&type=style&index=0&id=4afd368a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afd368a",
  null
  
)

export default component.exports